import { actionTypes } from '../actions'

const initialState = {
  name: null,
  picture: null,
  email: null,
  isAuthenticated: false,
}

export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_USER_DATA:
      return { ...state, ...action.payload }

    case actionTypes.CLEAR_USER_DATA:
      return initialState

    case actionTypes.SET_TOKENS:
      return state

    case actionTypes.REMOVE_TOKENS:
      return state

    case actionTypes.CHECK_AUTH:
      return state

    case actionTypes.LOG_OUT:
      return state

    default:
      return state
  }
}
